module.exports = process.env.COV
  ? require('./lib-cov/mocha')
  : require('./lib/mocha');



/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha/index.js
 ** module id = 52
 ** module chunks = 1
 **/